import { Textarea as ChakraTextarea, Field } from "@chakra-ui/react";
import { forwardRef } from "react";
import { useThemeConfig } from "../../hooks/useThemeConfig";

export const Textarea = forwardRef(
  /**
   * @param {import("@chakra-ui/react").TextareaProps & { invalid?: boolean; }} props
   */
  function Textarea({ invalid, ...otherProps }, ref) {
    const { textareaProps } = useThemeConfig();

    return (
      <Field.Root invalid={invalid}>
        <ChakraTextarea ref={ref} {...textareaProps} {...otherProps} />
      </Field.Root>
    );
  },
);
